import React from 'react'
import TabList from '@/components/content/TabList'
import OutboundUnallocatedTable from '@/pages/outbound/outboundUnallocated/components/OutboundUnallocatedTable'
import { OrderItem } from '@/services/outbound/outboundWaitingStatus/types'
import { ExcelDownloadType } from '@/services/excel/excel.types'

interface OutboundSearchBatchTableProps {
  items?: OrderItem[]
  pageInfo?: PageInfoType
  isLoading?: boolean
  currentPage?: number
  onChangePage?: (page: number) => void
  onExportData?: (params?: ExcelDownloadType) => void
  onReplanDone?: () => void
}
function OutboundUnallocatedList({
  items,
  pageInfo,
  isLoading,
  currentPage,
  onChangePage,
  onExportData,
  onReplanDone,
}: OutboundSearchBatchTableProps) {
  return (
    <TabList
      list={[
        {
          label: '미할당',
          key: 'OUTBOUND_UNALLOCATED',
          content: (
            <OutboundUnallocatedTable
              items={items}
              pageInfo={pageInfo}
              isLoading={isLoading}
              currentPage={currentPage}
              onChangePage={onChangePage}
              onExportData={onExportData}
              onReplanDone={onReplanDone}
            />
          ),
        },
        // TODO: [SCOPE B] 추가 예정
        // {
        //   label: '처리완료',
        //   key: 'OUTBOUND_COMPLETED',
        //   content: <OutboundCompletedTable />,
        // },
      ]}
    />
  )
}

export default OutboundUnallocatedList
